(function () {
  var accessibleTabsId = 0;

  function setupTabs(root) {
    root.querySelectorAll('tabs-component').forEach(function (component) {
      if (component.dataset.accessibleTabs === 'true') return;
      var tabs = Array.from(component.querySelectorAll('.tab-link'));
      var panels = Array.from(component.querySelectorAll('.tab-content'));
      if (!tabs.length) return;
      if (!component.id) {
        accessibleTabsId += 1;
        component.id = 'AccessibleTabs-' + accessibleTabsId;
      }
      var tabList = component.querySelector('.tabs');
      if (tabList) tabList.setAttribute('role', 'tablist');

      tabs.forEach(function (tab, index) {
        var panel = panels[index];
        var tabId = tab.id || component.id + '-Tab-' + index;
        var panelId = panel && panel.id ? panel.id : component.id + '-Panel-' + index;
        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panelId);
        if (panel) {
          panel.id = panelId;
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tabId);
        }
      });

      function syncState() {
        tabs.forEach(function (tab, index) {
          var selected = tab.classList.contains('current');
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (panels[index]) panels[index].setAttribute('aria-hidden', String(!selected));
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          window.requestAnimationFrame(syncState);
        });
        tab.addEventListener('keydown', function (event) {
          var nextIndex = index;
          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;
          if (nextIndex === index) return;
          event.preventDefault();
          tabs[nextIndex].focus();
          tabs[nextIndex].click();
        });
      });

      new MutationObserver(syncState).observe(component, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });
      component.dataset.accessibleTabs = 'true';
      syncState();
    });
  }

  function initialize(root) {
    setupTabs(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialize(document);
    });
  } else {
    initialize(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
  });
})();
